export default {"src":"/bnb/_next/static/media/halborn.d5d8d2ec.svg","height":20,"width":20};